var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInnospec(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 342.56 71.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b2bb1e;}.cls-2{fill:#974399;}.cls-3{fill:#0076c0;}.cls-4{fill:#ee3524;}.cls-5{fill:#231f20;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.62,263.6a15.09,15.09,0,1,0,5.52,20.61A15.08,15.08,0,0,0,540.62,263.6Z",
    transform: "translate(-225.1 -240.97)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M515.78,306.63V279.52a17.52,17.52,0,0,0,23.47,13.55Z",
    transform: "translate(-225.1 -240.97)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M567.66,276.67l-23.47,13.55a17.53,17.53,0,0,0,0-27.1Z",
    transform: "translate(-225.1 -240.97)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M515.78,246.71l23.47,13.56a17.52,17.52,0,0,0-23.47,13.54Z",
    transform: "translate(-225.1 -240.97)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M236.76,246.8a5.83,5.83,0,1,1-5.83-5.83A5.92,5.92,0,0,1,236.76,246.8Zm-.63,48.61h-10.4v-37h10.4Z",
    transform: "translate(-225.1 -240.97)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M255.31,257.35c10.56,0,19.06,7.17,19.06,16.86v21.2H264v-22.7a8.32,8.32,0,0,0-8.2-8.27c-1.1,0-2.12.08-3.15.16v30.81H242.24V268.3Z",
    transform: "translate(-225.1 -240.97)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M292.85,257.35c10.55,0,19.06,7.17,19.06,16.86v21.2h-10.4v-22.7a8.31,8.31,0,0,0-8.19-8.27c-1.11,0-2.13.08-3.15.16v30.81h-10.4V268.3Z",
    transform: "translate(-225.1 -240.97)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M315.85,276.89c0-11.34,9.68-19.46,20.55-19.46S357,265.55,357,276.89s-9.69,19.46-20.56,19.46S315.85,288.23,315.85,276.89Zm20.55-11.74c-4.57,0-9.84,3.39-9.84,11.74s5.27,11.74,9.84,11.74,9.85-3.39,9.85-11.74S341,265.15,336.4,265.15Z",
    transform: "translate(-225.1 -240.97)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M388.7,284.77c0,4.81-3.31,11.58-14.33,11.58a21.81,21.81,0,0,1-15.13-6.06l4-5.36a15,15,0,0,0,10.16,4c3.94,0,5.12-1.74,5.12-3,0-5.12-18.2-5.12-18.2-17.1,0-5.83,4.89-11.42,13.55-11.42a18.2,18.2,0,0,1,13,5.52l-4,5a12.26,12.26,0,0,0-8.42-3.31c-2.37,0-3.95,1.5-3.95,2.91C370.5,272.63,388.7,272.63,388.7,284.77Z",
    transform: "translate(-225.1 -240.97)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M405.12,257.43c13.55,0,22.22,10.09,22.22,20.48a18.31,18.31,0,0,1-18.43,18.44,20.23,20.23,0,0,1-5.91-.86v17.09H392.6V268.3ZM403,264.76V289a9.28,9.28,0,0,0,3,.47c4.41,0,10.63-3.47,10.63-11.51,0-8.35-5.59-13.31-11.1-13.31A25,25,0,0,0,403,264.76Z",
    transform: "translate(-225.1 -240.97)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M451,288.63a22.74,22.74,0,0,0,11.9-3.39l3.94,5.44A25.07,25.07,0,0,1,451,296.35c-10.86,0-20.55-8.12-20.55-19.46s9.69-19.46,20.55-19.46c11,0,18.28,8.43,18.28,19.93v2.37H441.36C442.38,286,447,288.63,451,288.63Zm0-23.48c-3.93,0-8.42,2.52-9.6,8.59h17.72C458.68,268.07,454.9,265.15,451,265.15Z",
    transform: "translate(-225.1 -240.97)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M492.39,296.35c-10.78,0-20.47-8.12-20.47-19.46s9.69-19.46,20.56-19.46c4.72,0,9.13,1.58,13.94,5.12L503,268.3a19.54,19.54,0,0,0-10.55-3.15c-4.58,0-9.85,3.39-9.85,11.74s5.2,11.74,9.85,11.74a21.57,21.57,0,0,0,10.71-2.84l3.38,6.07A24.43,24.43,0,0,1,492.39,296.35Z",
    transform: "translate(-225.1 -240.97)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnospec);
export default __webpack_public_path__ + "static/media/Innospec.40c76c4a4bb21d8567c6c44c1267d5ed.svg";
export { ForwardRef as ReactComponent };